// This mixins help to reduce the number of lines necessary to prompt a toast message
// from a component.

const toastsMixins = {
    successToast (body, title = 'Éxito!') {
        this.$bvToast.toast(
            body,
            {
                title: title,
                variant: 'success',
                solid: true,
                append: true
            }
        )
    },
    unknownErrorToast () {
        this.$bvToast.toast(
            'Ocurrió algo inesperado, recomendamos recargar la página.',
            {
                title: 'Error!',
                variant: 'danger',
                solid: true,
                append: true
            }
        )
    },
    dangerToast (body, title = 'Error!') {
        this.$bvToast.toast(
            body,
            {
                title: title,
                variant: 'danger',
                solid: true,
                append: true
            }
        )
    },
    warningToast (body, title = 'Peligro!') {
        this.$bvToast.toast(
            body,
            {
                title: title,
                variant: 'warning',
                solid: true,
                append: true
            }
        )
    },
    infoToast (body, title = 'Notificación') {
        this.$bvToast.toast(
            body,
            {
                title: title,
                variant: 'info',
                solid: true,
                append: true
            }
        )
    }
}

export default toastsMixins
